// @flow
import * as types from '../constants/action_types'
import type { WindowStateType } from '../reducers/logger'

export const setTabbedPanelIndex = (tabindex: number) => ({ type: types.TABBED_PANEL_INDEX, tabindex })
export const setTabbedPanelWindowState = (windowState: WindowStateType) => ({ type: types.TABBED_PANEL_WINDOW_STATE, windowState })
